import { JobTaskDetailSchema } from "@augmodo/lebron-browser-client";
import { useCompleteJobTask } from "@labeling-tools/api/lebron/react-query-hooks";
import { Button } from "@mantine/core";
import { useParams } from "react-router-dom";
import { PRODUCT_ASSOCIATION_MODEL_ID } from "../config/data";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { useQueryClient } from "@tanstack/react-query";
import { reset } from "@/store";

export const PAPlanogramModalActions = ({
  task,
  onClose,
  selectedProductId,
  planogramId,
}: {
  task: JobTaskDetailSchema;
  onClose: () => void;
  selectedProductId: string;
  planogramId?: string;
}) => {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { jobId } = useParams<{ jobId: string }>();
  const { mutateAsync: completeJobTask, isPending: isCompletingJobTask } =
    useCompleteJobTask(jobId || "", task.id || "");
  const searchTerms = useAppSelector(
    (state) => state.productAssociation.searchTerms,
  );
  const stagedSelectedItem = useAppSelector(
    (state) => state.productAssociation.stagedSelectedItem,
  );
  const badDetection = useAppSelector(
    (state) => state.productAssociation.badDetection,
  );
  const embeddingId =
    selectedProductId === stagedSelectedItem?.entity_id
      ? stagedSelectedItem?.id
      : null;

  const handleConfirmItem = async () => {
    const resultData = {
      planogram_id: planogramId || null,
      entity_id: selectedProductId,
      model_id: PRODUCT_ASSOCIATION_MODEL_ID,
      search_terms: searchTerms,
      embedding_id: embeddingId,
      planogram_submitted: true,
      bad_detection: badDetection,
    };
    await completeJobTask({
      result: resultData,
    });
    dispatch(reset());
    queryClient.invalidateQueries({ queryKey: ["nextPendingTask", jobId] });
    onClose();
  };
  return (
    <div className="flex justify-end gap-2 absolute bottom-0 right-0 left-0 z-50 p-2">
      <Button style={{ minWidth: 100 }} variant="outline" onClick={onClose}>
        Exit
      </Button>
      <Button
        style={{ minWidth: 100 }}
        onClick={handleConfirmItem}
        loading={isCompletingJobTask}
      >
        Submit
      </Button>
    </div>
  );
};
